import { CalendarRange } from "lucide-react";

// Expected notification months for 2026 — based on historical release pattern.
// Sourced from official commission calendars (SSC, UPSC, IBPS, RRB, MoD, MoE).
const TIMELINE = [
  { month: "March 2026", events: [
    { sector: "SSC", title: "SSC CGL 2026 — Notification" },
    { sector: "Railway", title: "RRB JE — Expected notification" },
    { sector: "Defense", title: "AFCAT-2 — Expected" },
  ]},
  { month: "April 2026", events: [
    { sector: "SSC", title: "SSC CHSL 2026 — Notification" },
    { sector: "Banking", title: "SBI PO 2026 — Expected" },
    { sector: "Teaching", title: "CTET July session — Notification" },
  ]},
  { month: "May 2026", events: [
    { sector: "UPSC", title: "UPSC CSE 2026 — Prelims (24 May)" },
    { sector: "Railway", title: "RRB ALP CBT-1" },
    { sector: "State Govt", title: "UPPSC PCS 2026 — Prelims" },
  ]},
  { month: "June 2026", events: [
    { sector: "Banking", title: "IBPS PO 2026 — Notification" },
    { sector: "PSU", title: "PSU GATE-based recruitment cycle" },
    { sector: "Defense", title: "NDA-2 — Notification" },
  ]},
  { month: "July 2026", events: [
    { sector: "SSC", title: "SSC JE 2026 — Expected notification" },
    { sector: "Teaching", title: "KVS PRT/TGT 2026 — Expected" },
  ]},
  { month: "August 2026", events: [
    { sector: "Banking", title: "IBPS Clerk + RRB — Notifications" },
    { sector: "Railway", title: "Railway Group D — Expected fresh notification" },
  ]},
];

const SECTOR_COLOR = {
  "SSC": "bg-orange-100 text-orange-700",
  "Railway": "bg-blue-100 text-blue-700",
  "UPSC": "bg-purple-100 text-purple-700",
  "Banking": "bg-emerald-100 text-emerald-700",
  "Defense": "bg-red-100 text-red-700",
  "Teaching": "bg-yellow-100 text-yellow-800",
  "State Govt": "bg-indigo-100 text-indigo-700",
  "PSU": "bg-slate-200 text-slate-700",
};

export default function ExamTimeline() {
  return (
    <section
      className="bg-white border border-slate-200 rounded-xl p-5 md:p-6"
      aria-labelledby="exam-timeline-h2"
      data-testid="exam-timeline"
    >
      <div className="flex items-center gap-2 mb-1">
        <span className="inline-grid place-items-center w-8 h-8 rounded-md bg-orange-100 text-orange-700">
          <CalendarRange className="w-4 h-4" aria-hidden="true" />
        </span>
        <h2
          id="exam-timeline-h2"
          className="text-lg md:text-xl font-extrabold text-slate-900"
          style={{ fontFamily: "'Cabinet Grotesk',sans-serif" }}
        >
          Upcoming Exam Calendar
        </h2>
      </div>
      <p className="text-xs text-slate-600 mb-4">
        Expected notification months — based on official commission patterns.
      </p>

      <ol className="relative border-l-2 border-orange-200 ml-2 pl-5 space-y-5">
        {TIMELINE.map((m) => (
          <li key={m.month} className="relative" data-testid={`timeline-${m.month.split(" ")[0].toLowerCase()}`}>
            <span className="absolute -left-[26px] top-1 w-3 h-3 rounded-full bg-orange-600 ring-4 ring-orange-50" aria-hidden="true" />
            <div className="text-xs font-bold uppercase tracking-wider text-orange-600 mb-1">{m.month}</div>
            <ul className="space-y-1.5">
              {m.events.map((e, i) => (
                <li key={i} className="text-sm text-slate-700 flex items-start gap-2 leading-snug">
                  <span className={`text-[10px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded ${SECTOR_COLOR[e.sector] || "bg-slate-100 text-slate-600"} flex-shrink-0 mt-0.5`}>
                    {e.sector}
                  </span>
                  <span>{e.title}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
      <p className="mt-4 text-[11px] text-slate-500 leading-relaxed">
        Dates are based on prior-year cycles and may shift. Always confirm with the official notification.
      </p>
    </section>
  );
}
